import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

import type { SearchLocationTheme } from '../hooks/useSearchLocationFilter';

const STYLES = {
  rose: {
    cardBorder: 'border-zinc-200 dark:border-zinc-800',
    cardBg: 'bg-white dark:bg-zinc-900',
    badgeBg: 'bg-zinc-100 dark:bg-zinc-800',
    badgeText: 'text-zinc-800 dark:text-zinc-200',
    label: 'text-zinc-500 dark:text-zinc-400',
    location: 'text-zinc-900 dark:text-zinc-100',
    hint: 'text-zinc-400 dark:text-zinc-500',
    btnBg: 'bg-zinc-900 dark:bg-zinc-50',
    btnText: 'text-white dark:text-zinc-950',
    clearText: 'text-zinc-700 dark:text-zinc-300',
  },
  orange: {
    cardBorder: 'border-zinc-200 dark:border-zinc-800',
    cardBg: 'bg-white dark:bg-zinc-900',
    badgeBg: 'bg-zinc-100 dark:bg-zinc-800',
    badgeText: 'text-zinc-800 dark:text-zinc-200',
    label: 'text-zinc-500 dark:text-zinc-400',
    location: 'text-zinc-900 dark:text-zinc-100',
    hint: 'text-zinc-400 dark:text-zinc-500',
    btnBg: 'bg-zinc-900 dark:bg-zinc-50',
    btnText: 'text-white dark:text-zinc-950',
    clearText: 'text-zinc-700 dark:text-zinc-300',
  },
} as const;

type Props = {
  theme: SearchLocationTheme;
  effectiveCity: string;
  effectiveDistrict: string;
  isTemporaryFilter: boolean;
  onChangePress: () => void;
  onClearFilter?: () => void;
  /** Misafir: konum CTA ve ipuçları */
  isGuest?: boolean;
};

export function SearchLocationBanner({
  theme,
  effectiveCity,
  effectiveDistrict,
  isTemporaryFilter,
  onChangePress,
  onClearFilter,
  isGuest,
}: Props) {
  const t = STYLES[theme];
  const hasLocation = Boolean(effectiveCity?.trim());
  const primaryActionLabel =
    isGuest && !hasLocation ? 'Konum Seç 📍' : 'Konum Değiştir 📍';
  const locationLine = effectiveDistrict?.trim()
    ? `${effectiveCity} · ${effectiveDistrict.trim()}`
    : effectiveCity?.trim()
      ? `${effectiveCity.trim()} (il geneli)`
      : '';

  return (
    <View className={`mb-4 rounded-2xl border ${t.cardBorder} ${t.cardBg} px-5 py-4`}>
      <View className="flex-row items-start justify-between gap-2">
        <View className="min-w-0 flex-1">
          <Text className={`text-xs font-medium ${t.label}`}>Arama konumu</Text>
          {hasLocation ? (
            <View className="mt-1 flex-row flex-wrap items-center gap-2">
              <Text className={`text-sm font-semibold ${t.location}`}>{locationLine}</Text>
              {isTemporaryFilter ? (
                <View className={`rounded-full px-2 py-0.5 ${t.badgeBg}`}>
                  <Text className={`text-[10px] font-bold uppercase tracking-wide ${t.badgeText}`}>
                    Filtrelendi
                  </Text>
                </View>
              ) : (
                <Text className="text-[11px] text-zinc-400 dark:text-zinc-500">Profil konumun</Text>
              )}
            </View>
          ) : (
            <Text className={`mt-1 text-sm ${t.hint}`}>
              Konum seçerek bu bölgedeki içerikleri görebilirsin.
            </Text>
          )}
          {hasLocation ? (
            <Text className={`mt-2 text-xs ${t.hint}`}>
              {isGuest
                ? 'Kayıt olarak profilinde kalıcı adresini kaydedebilirsin.'
                : 'Kalıcı değişiklik için Profilim’den il/ilçe güncelle.'}
            </Text>
          ) : null}
        </View>
      </View>
      <View className="mt-4 flex-row flex-wrap items-center gap-3">
        <TouchableOpacity
          activeOpacity={0.88}
          onPress={onChangePress}
          className={`rounded-2xl px-5 py-3 ${t.btnBg}`}>
          <Text className={`text-center text-sm font-semibold ${t.btnText}`}>
            {primaryActionLabel}
          </Text>
        </TouchableOpacity>
        {isTemporaryFilter && onClearFilter ? (
          <TouchableOpacity
            activeOpacity={0.85}
            onPress={onClearFilter}
            className="rounded-2xl border border-zinc-200 bg-zinc-50 px-4 py-3 dark:border-zinc-700 dark:bg-zinc-800">
            <Text className={`text-sm font-semibold ${t.clearText}`}>Filtreyi temizle</Text>
          </TouchableOpacity>
        ) : null}
      </View>
    </View>
  );
}
